import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeEmailAccountCreate,
  detail: routeEmailAccountDetail,
  home: routeEmailAccountHome,
  root: routeEmailAccountRoot,
} = createDoctypeRoutes({
  createName: 'new-email-account',
  createPath: 'new-email-account',
  detailName: 'email-account-detail',
  doctype: DOCTYPES.EMAIL_ACCOUNT,
  homeName: 'email-account',
  path: 'email-account',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/email/emailAccount/AddEmailAccount.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/email/emailAccount/ViewEmailAccount.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  },
})

export {
  routeEmailAccountCreate,
  routeEmailAccountDetail,
  routeEmailAccountHome,
  routeEmailAccountRoot,
}
